import Alert from '@mui/material/Alert'
import Slide from '@mui/material/Slide'
import Snackbar from '@mui/material/Snackbar'
import * as React from 'react'
import { AddData } from '../../redux/Reducers/DynamicDataStore'
import { dispatch, useSelector } from '../../redux/store'
function SlideTransition(props) {
  return <Slide {...props} direction="left" />
}

export default function CustomSnackbar() {
  const open = useSelector(state => state.dynamicStore.snackbar)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    dispatch(AddData({ name: 'snackbar', data: false }))
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={handleClose}
        severity={open?.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {open?.message}
      </Alert>
    </Snackbar>
  )
}
